import script from "./AppointmentList.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppointmentList.vue?vue&type=script&lang=ts&setup=true"

import "./AppointmentList.vue?vue&type=style&index=0&id=4192d828&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4192d828"]])

export default __exports__